/**
 * Guest_Service.ts
 * Guest QR self-join — no JWT; tenant/location come from the QR payload.
 * Uses guestClient (no cookie / no Bearer).
 */

import { guestClient } from '../../api/axiosInstance';
import { Hosp_Guest_Otp_Request_Url, Hosp_Guest_Otp_Verify_Url, Hosp_Guest_Session_Url } from '../../api/endpoints';
import type { GuestOtpRequestInput, GuestOtpVerifyInput, GuestOtpVerifyResult } from '../../schemas/guest/guest';

export const requestGuestOtp = async (input: GuestOtpRequestInput): Promise<any> => {
  const { data } = await guestClient.post(Hosp_Guest_Otp_Request_Url, input);
  return data;
};

export const verifyGuestOtp = async (input: GuestOtpVerifyInput): Promise<GuestOtpVerifyResult> => {
  const { data } = await guestClient.post<GuestOtpVerifyResult>(Hosp_Guest_Otp_Verify_Url, input);
  return data;
};

export const getGuestSession = async (token: string): Promise<any> => {
  const { data } = await guestClient.get(Hosp_Guest_Session_Url(token));
  return data;
};
